import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { Product } from 'features/types'

type ProductsListSelector = (state: ReduxState, campaignId: number) => Product[]
const getProductsList: ProductsListSelector = (state, campaignId) => {
  const result = [] as Product[]
  if (
    Object.prototype.hasOwnProperty.call(state.products.pagination, campaignId) &&
    Object.prototype.hasOwnProperty.call(state.products.campaignProducts, campaignId)
  ) {
    const { pages, currentPage } = state.products.pagination[campaignId]
    const pageProductIds = pages[currentPage] || []

    pageProductIds.forEach((productId) => {
      result.push(state.products.campaignProducts[campaignId][productId])
    })
  }

  return result
}

export const productsListSelector: ProductsListSelector = createSelector(getProductsList, (list) => list)
